import { useMemo } from 'react';
import * as React from 'react';

import TrashButton from '@/components/elements/Button/TrashButton';
import Counter from '@/components/elements/Form/Counter';
import CompositeOdds from '@/components/elements/Text/CompositeOdds';
import OddsRange from '@/components/elements/Text/OddsRange';
import SetNumber from '@/components/elements/Text/SetNumber';
import { BetDetail, OddsData, OrderStep, Ticket } from '@/modelTypes';

import RefundRange from '../Pertials/RefundRange';
import { ButtonWrapper } from '../style';
import {
  Detail,
  DetailWrapper,
  Odds,
  OddsDetail,
  OddsWrapper,
  Refund,
  TicketsWrapper,
} from './style';

interface ExpandListProps {
  betDetail: BetDetail;
  orderStep: OrderStep;
  oddsData: OddsData;
  hashKey: string;
  changeCount: (
    value: number,
    itemId: string,
    setNum?: number | undefined,
  ) => void;
  deleteTicket: (itemId: string, setNum?: number | undefined) => void;
}

const ExpandList: React.FC<ExpandListProps> = ({
  betDetail,
  orderStep,
  oddsData,
  hashKey,
  changeCount,
  deleteTicket,
}) => {
  const arrayOfSetNum = (tickets: Ticket[]) => tickets.map(t => t.setNum);
  const isConfirmStep = useMemo(
    () => orderStep === OrderStep.Confirm,
    [orderStep],
  );

  return (
    <TicketsWrapper>
      <OddsWrapper>
        <OddsDetail>
          <p>オッズ</p>
          <OddsRange
            odds={oddsData.exists ? oddsData.data : null}
            setNums={arrayOfSetNum(betDetail.tickets)}
            betType={betDetail.betType}
          />
        </OddsDetail>
        <OddsDetail>
          <p>合成オッズ</p>
          <CompositeOdds
            odds={oddsData.exists ? oddsData.data : null}
            setNums={arrayOfSetNum(betDetail.tickets)}
            betType={betDetail.betType}
          />
        </OddsDetail>
      </OddsWrapper>
      {betDetail.tickets.map(ticket => (
        <DetailWrapper key={ticket.setNum}>
          <Detail disabled={ticket.isRemoved}>
            <SetNumber
              setNums={arrayOfSetNum([ticket])}
              betType={betDetail.betType}
            />
            <Odds>
              <OddsRange
                odds={oddsData.exists ? oddsData.data : null}
                setNums={[ticket.setNum]}
                betType={betDetail.betType}
              />
            </Odds>
            <Refund>
              <RefundRange
                setNums={[ticket.setNum]}
                betType={betDetail.betType}
                count={ticket.count}
                odds={oddsData.exists ? oddsData.data : null}
              />
            </Refund>
          </Detail>
          <ButtonWrapper>
            <Counter
              value={ticket.count}
              min={1}
              max={999}
              disabled={ticket.isRemoved || isConfirmStep}
              onChange={val => changeCount(val, hashKey, ticket.setNum)}
            />
            <TrashButton
              isRemoved={ticket.isRemoved}
              disabled={isConfirmStep}
              onClick={() => deleteTicket(hashKey, ticket.setNum)}
            />
          </ButtonWrapper>
        </DetailWrapper>
      ))}
    </TicketsWrapper>
  );
};

export default ExpandList;
